// Copyright (c) 2026 杨翔宇（武汉文理学院）
// 物理智能教学智能体平台 (Physics Intelligent Agent)
// 保留所有权利 (All Rights Reserved)。未经著作权人书面许可，
// 不得以任何形式复制、传播、修改或用于商业用途。

import { extractRetryAfterSeconds } from './errorMessage';

/**
 * Shared failure-retry policy for idempotent background GETs.
 *
 * 优先采用服务端 Retry-After 提示（秒）；无提示用默认 15s，并统一夹取到
 * [5s, 60s]——既尊重服务端的限流节奏，也保证重试频率有界。
 */
export const RETRY_DELAY_DEFAULT_MS = 15_000;
export const RETRY_DELAY_MIN_MS = 5_000;
export const RETRY_DELAY_MAX_MS = 60_000;

export function resolveRetryDelayMs(error: unknown): number {
  const retryAfterSeconds = extractRetryAfterSeconds(error);
  if (retryAfterSeconds === null) {
    return RETRY_DELAY_DEFAULT_MS;
  }
  return Math.min(
    RETRY_DELAY_MAX_MS,
    Math.max(RETRY_DELAY_MIN_MS, retryAfterSeconds * 1000)
  );
}
